import { useState } from 'react'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useDeleteUserMutation } from 'actions/users'
import { deleteUser as deleteStateUser } from 'slices/user'
import { useNavigate } from 'react-router-dom'


function Delete({ uuid, redirect=false, children }) {
  const [show, setShow] = useState(false)
  const dispatch = useDispatch()
  const [deleteUser, { isLoading }] = useDeleteUserMutation()
  const navigate = useNavigate()

  const dltBtn = {
    cursor: 'wait',
    opacity: '0.5'
  }

  const deleteHandler = async () => {
    const { data, error } = await deleteUser(uuid)
    if (data) {
      toast.success('User deleted successfully')
      dispatch(deleteStateUser(uuid))
      setShow(false)
      redirect && navigate('/admin/users')
    } else if (error) {
      toast.error('fail to delete user')
    }

  }

  return (
    <>
      <div onClick={() => setShow(true)}>
        {children}
      </div>

      <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: 'block', backgroundColor: '#00000061', visibility: show ? 'visible' : 'hidden', opacity: show ? 1 : 0, transition: 'visibility 0s, opacity 0.5s linear' }} id='exampleModalCenter' tabIndex='-1' role='dialog' aria-labelledby='exampleModalCenterTitle' aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title' id='exampleModalLongTitle'>Delete User</h5>
              <button onClick={() => !isLoading && setShow(false)} type='button' className='close border-0' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              You are about to delete user from database. This action can not be undo.
              Are you sure to proceed this action? Click Delete to delete user.
            </div>
            <div className='modal-footer'>
              <button style={isLoading ? dltBtn : {}} type='button' className='btn btn-secondary' data-dismiss='modal' onClick={() => !isLoading && setShow(false)}>Cancel</button>
              <button style={isLoading ? dltBtn : {}} onClick={() => !isLoading && deleteHandler()} type='button' className='btn btn-primary'>{isLoading ? 'isLoading user...' : 'Delete user'}</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

Delete.propTypes = {
  uuid: PropTypes.string.isRequired,
  redirect: PropTypes.bool,
  children: PropTypes.element.isRequired
}

export default Delete